import { render, staticRenderFns } from "./SithMesInventoryItemEdit.vue?vue&type=template&id=687f377e&"
import script from "./SithMesInventoryItemEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports